module.exports = __webpack_public_path__ + "static/media/Valley-night.ee925e11.svg";